import React, { useState } from "react";
import { useEffect } from "react";
import ReactDOM from "react-dom";
import { Link, useLocation, useNavigate } from "react-router-dom";
import AuthService from "../../services/auth.service";
import { ToastContainer, toast, Slide } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";
import moment from "moment";
import { API_URL } from "../../utilities/url";
import { FiPlus } from "react-icons/fi";
import storage from "../../services/storage";
import { FaRegTrashAlt } from "react-icons/fa";
import axios from "axios";
import authHeader from "../../services/auth.header";
import { HiOutlineRefresh } from "react-icons/hi";
import CryptoJS from "crypto-js";
import { Dropdown } from "react-bootstrap";
import { MdFileUpload, MdFilterList, MdSearch } from "react-icons/md";
import { PiListBold } from "react-icons/pi";
import { RxDashboard } from "react-icons/rx";
import { IoMdCloseCircle } from "react-icons/io";
import CardList from "./component/cardList";
import TableList from "./component/tableList";
import UploadMediaModal from "./component/uploadMediaModal";
import Pagination from "./component/pagination";
import {
  format_number,
  formatFileSize,
  formatFileSizeMB,
} from "../../utilities/ext-function";
import authService from "../../services/auth.service";

var $ = require("jquery");

const MediaStorage = () => {
  const location = useLocation();
  const getSlidesConfig = (width) => {
    if (width > 3000) {
      return 50;
    } else if (width <= 3000 && width > 2500) {
      return 42;
    } else if (width <= 2500 && width > 2000) {
      return 35;
    } else if (width <= 2000 && width > 1500) {
      return 30;
    } else if (width <= 1500 && width > 1024) {
      return 25;
    } else if (width <= 1024 && width > 600) {
      return 20;
    } else if (width <= 600) {
      return 10;
    } else {
      return 50;
    }
  };
  const decryptUSR = CryptoJS.AES.decrypt(storage.get("user"), "user").toString(
    CryptoJS.enc.Utf8
  );
  const dt_user = JSON.parse(decryptUSR);
  const decryptWS = CryptoJS.AES.decrypt(storage.get("wrs"), "wrs").toString(
    CryptoJS.enc.Utf8
  );
  const workspace = JSON.parse(decryptWS);
  const [listView, setListView] = useState("card");
  const [cardsData, setCardsData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(null);
  const [totalItems, setTotalItem] = useState(0);
  const [totalFileSize, setTotalFileSize] = useState(0);
  const itemPerPages = getSlidesConfig(window.innerWidth);
  // const itemPerPages = 5;
  const [reloadData, setReloadData] = useState(false);
  const [searchValue, setSearchValue] = useState(null);
  const [debouncedSearch, setDebouncedSearch] = useState(null);
  const [loading, setLoading] = useState(false);
  const optionSort = [
    {
      value: "a-asc",
      label: "Alphabetical A-Z",
    },
    {
      value: "a-desc",
      label: "Alphabetical Z-A",
    },
    {
      value: "l-desc",
      label: "Last Uploaded",
    },
  ];
  const [selectedSorting, setSelectedSorting] = useState(() => {
    const sorted = storage.get("sortedData");
    return sorted ? sorted : optionSort[2];
  });

  const handleSorting = (data) => {
    setSelectedSorting(data);
    storage.setUnlimited("sortedData", data);
  };

  const handleListView = (view) => setListView(view);
  const handlePageChange = (page) => setCurrentPage(page);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(searchValue);
    }, 500);

    return () => clearTimeout(handler);
  }, [searchValue]);

  useEffect(() => {
    if (debouncedSearch || debouncedSearch === "") {
      getMedia();
    }
  }, [debouncedSearch]);

  useEffect(() => {
    getMedia();
  }, [currentPage, selectedSorting, location.key]);

  const getMedia = () => {
    setLoading(true);
    axios
      .post(
        API_URL + "get-media-storage",
        {
          idt_workspace: workspace.idt_user_workspace,
          name: searchValue,
          sort: selectedSorting.value,
          page: currentPage,
          limit: itemPerPages,
        },
        {
          headers: {
            Authorization: `Bearer ${storage.get("access_token")}`,
          },
        }
      )
      .then((res) => {
        if (res.data.success === true) {
          setCardsData(res.data.data.data);
          setTotalItem(res.data.data.meta.total_items);
          setTotalPages(res.data.data.meta.total_pages);
          setTotalFileSize(res.data.data.meta.total_filesize);
          setLoading(false);
        }
      })
      .catch((error) => {
        if (error.response.data.message) {
          authService.logout();
        }
      });
  };

  const handleUploadSuccess = () => {
    setSelectedSorting(optionSort[2]);
    storage.setUnlimited("sortedData", optionSort[2]);
  };

  const handleDelete = (id, filesize) => {
    axios
      .post(
        API_URL + "delete-media-storage",
        {
          idt_workspace: workspace.idt_user_workspace,
          file_id: id,
        },
        {
          headers: {
            Authorization: `Bearer ${storage.get("access_token")}`,
          },
        }
      )
      .then((res) => {
        if (res.data.success) {
          toast.success(res.data.message, {
            position: "top-right",
            theme: "colored",
            transition: Slide,
            autoClose: 4000,
            hideProgressBar: true,
            closeOnClick: true,
            draggable: true,
            progress: undefined,
          });
          setCurrentPage((prevPage) => {
            const remainingItems = cardsData.filter(
              (card) => card.fileid !== id
            );
            if (remainingItems.length === 0 && prevPage > 1) {
              return prevPage - 1;
            }
            setCardsData(remainingItems);
            return prevPage;
          });
          setTotalFileSize((prev) => prev - filesize);
        } else {
          toast.error(res.data.message, {
            position: "top-right",
            theme: "colored",
            transition: Slide,
            autoClose: 4000,
            hideProgressBar: true,
            closeOnClick: true,
            draggable: true,
            progress: undefined,
          });
        }
      })
      .catch((error) => {
        if (error.response.data.message) {
          authService.logout();
        }
      });
  };

  return (
    <div className="container-fluid p-0">
      <ToastContainer />
      <div className="row">
        <div className="col-12">
          <div className="card rounded-4 shadow-lg">
            <div className="card-header rounded-4">
              <div className="d-flex justify-content-between align-items-center">
                <div className="card-title mt-2">Media Storage</div>
                <div className="mt-2">
                  <div className="progress">
                    <div
                      className="progress-bar bg-orange"
                      role="progressbar"
                      style={{
                        width: `${
                          totalFileSize && 52428800
                            ? ((totalFileSize / 52428800) * 100).toFixed(2)
                            : 0
                        }%`,
                      }}
                      aria-valuenow={totalFileSize}
                      aria-valuemin={0}
                      aria-valuemax={52428800}
                    ></div>
                  </div>
                  <p className="mb-0">
                    {formatFileSizeMB(totalFileSize)} out of{" "}
                    {formatFileSizeMB(52428800)} has been used
                  </p>
                </div>
              </div>
            </div>
            <div className="card-body">
              <div className="row">
                <div className="">
                  <div className="d-flex align-items-center">
                    <nav className="nav btn-group rounded-pill me-2">
                      <button
                        className={`btn waves-effect waves-light btn-outline-dark ${
                          listView === "card" ? "active" : ""
                        }`}
                        onClick={() => handleListView("card")}
                      >
                        <RxDashboard />
                      </button>
                      <button
                        className={`btn waves-effect waves-light btn-outline-dark ${
                          listView === "table" ? "active" : ""
                        }`}
                        onClick={() => handleListView("table")}
                      >
                        <PiListBold />
                      </button>
                    </nav>
                    <div className="me-2">
                      <Dropdown align="end" flip={false}>
                        <Dropdown.Toggle
                          variant="none"
                          className="btn btn-upload-wd d-flex align-items-center"
                        >
                          <MdFilterList size={17} className="me-2" />
                          {selectedSorting.label}
                        </Dropdown.Toggle>

                        <Dropdown.Menu
                          placement="bottom-end"
                          style={{ marginTop: "40px" }}
                        >
                          {optionSort.map((option) => (
                            <Dropdown.Item
                              key={option.value}
                              onClick={() => handleSorting(option)}
                            >
                              {option.label}
                            </Dropdown.Item>
                          ))}
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                    <div className="app-search">
                      <div className="position-relative">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Search..."
                          autoComplete="off"
                          style={{ width: "200px" }}
                          value={searchValue}
                          onChange={(e) => setSearchValue(e.target.value)}
                          // onKeyPress={handleKeyPress}
                        />
                        <span className="search-widget-icon cursor-pointer">
                          <MdSearch size={18} />
                        </span>

                        {searchValue && (
                          <span
                            onClick={() => setSearchValue("")}
                            className="search-widget-icon search-widget-icon-close cursor-pointer"
                            id="search-close-options"
                          >
                            <IoMdCloseCircle size={18} />
                          </span>
                        )}
                      </div>
                    </div>
                    <UploadMediaModal onUploadSuccess={handleUploadSuccess} />
                  </div>
                  <hr />
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  {listView === "card" ? (
                    <CardList
                      cards={cardsData}
                      loading={loading}
                      onHandleDelete={handleDelete}
                    />
                  ) : (
                    <TableList
                      cards={cardsData}
                      loading={loading}
                      onHandleDelete={handleDelete}
                    />
                  )}
                  {totalItems > itemPerPages && totalPages > 1 && (
                    <Pagination
                      totalPages={totalPages}
                      currentPage={currentPage}
                      onPageChange={handlePageChange}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MediaStorage;
